"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Styles = _interopRequireWildcard(require("./Spinner.styles"));
var _Spinner2 = require("./Spinner.types");
var _classnames = _interopRequireDefault(require("./classnames"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var getA11yProps = function getA11yProps(percentage, statusDescription) {
  return {
    undetermined: {
      role: 'status',
      'aria-live': 'assertive',
      'aria-valuetext': statusDescription
    },
    determined: {
      role: 'progressbar',
      'aria-valuetext': statusDescription,
      'aria-valuemin': 0,
      'aria-valuemax': 100,
      'aria-valuenow': percentage
    }
  };
};
var checkProgress = function checkProgress(percentage) {
  return typeof percentage === 'number' && percentage >= 0 && percentage <= 100;
};
var Spinner = function Spinner(_ref) {
  var kind = _ref.kind,
    percentage = _ref.percentage,
    statusDescription = _ref.statusDescription;
  var isValidPercentage = checkProgress(percentage);
  var _getA11yProps = getA11yProps(percentage, statusDescription),
    undetermined = _getA11yProps.undetermined,
    determined = _getA11yProps.determined;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: _classnames["default"].SPINNER,
    width: 24,
    height: 24
  }, isValidPercentage ? determined : undetermined), /*#__PURE__*/_react["default"].createElement("title", null, statusDescription), /*#__PURE__*/_react["default"].createElement(Styles.BaseCircle, {
    $kind: kind
  }), isValidPercentage ? /*#__PURE__*/_react["default"].createElement(Styles.ProgressCircle, {
    className: _classnames["default"].SPINNER_PROGRESS_CIRCLE,
    $kind: kind,
    $percentage: percentage
  }) : /*#__PURE__*/_react["default"].createElement(Styles.LoopCircle, {
    className: _classnames["default"].SPINNER_LOOP_CIRCLE,
    $kind: kind
  }));
};
Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  kind: _propTypes["default"].oneOf(Object.values(_Spinner2.Kind)),
  percentage: (0, _Spinner2.ProgressPercentagePropType)(0, 100),
  statusDescription: _propTypes["default"].string
} : {};
Spinner.defaultProps = {
  kind: _Spinner2.Kind.DEFAULT
};
var _default = exports["default"] = Spinner;